import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import ImageEditorPop from "../imageEditors/ImageEditorPop";
import ImageEditorUpdPop from "../imageEditors/ImageEditorUpdatePop";
import AddVideoLink from "./AddVideoLink";

// assets
import videoIcon from "bodycodi/cmap/app/img/add-comunity-video.png";
import linkIcon from "bodycodi/cmap/app/img/add-comunity-link.png";
import pictureIcon from "bodycodi/cmap/app/img/add-comunity-picture.png";

// types
import { BottomButtonsProps } from "./types";

// utils
import { api } from "bodycodi/cmap/app/js/api";

const BottomButtons = ({
  imageFiles,
  videoFiles,
  setImageFiles,
  setVideoFiles,
  imageToEdit,
  setImageToEdit,
  imageFileRef,
  openAddLink,
  setOpenAddLink,
  videoLinks,
  setVideoLinks,
  linkToEdit,
  setLinkToEdit,
}: BottomButtonsProps) => {
  const { seqPartnerCoach, seqPartner } = useSelector((state: RootState) => state.partner);
  const { dispatch } = useContext(DispatchContext);

  const handleSelectImageButton = () => {
    if (imageFiles.length === 4) {
      dispatch({
        type: "UPDATE",
        data: { toast1: true, toastText: "이미지는 최대 4개까지 올릴 수 있어요." },
      });
      return null;
    }
  };

  const handleAddLinkButton = () => {
    if (videoLinks.length === 1) {
      dispatch({
        type: "UPDATE",
        data: { toast1: true, toastText: "YouTube 링크는 1개만 올릴 수 있어요." },
      });
    } else {
      setOpenAddLink(true);
    }
  };

  const handleSelectVideoButton = () => {
    if (videoFiles.length === 1) {
      dispatch({
        type: "UPDATE",
        data: { toast1: true, toastText: "동영상은 1개만 올릴 수 있어요." },
      });
      return null;
    }
  };

  const selectImageFile = () => {
    setImageToEdit({});
    dispatch({
      type: "POP_UP_OPEN",
      id: "ADD_COMUUNITY_EDITOR",
      open: { addComunityEditor: true },
    });
  };

  const getImageData = (s: any, name: string) => {
    imageFiles.push({ index: imageFiles.length, data: s, fileNm: name });
    setImageFiles([...imageFiles]);
  };

  const getImageDataUpd = (s: any, name: string) => {
    let index = 0;
    for (let i = 0; i < imageFiles.length; i++) {
      if (imageFiles[i].index === imageToEdit.index) {
        index = i;
      }
    }
    imageFiles[index] = { index: imageToEdit.index, data: s, fileNm: name };
    setImageFiles([...imageFiles]);
  };

  const selectVideoFile = (e: any) => {
    if (e.target?.files[0]?.size === 0) return null;
    const newInput = e.target?.files[0];
    const maxSize = 50 * 1000 * 1000;
    if (newInput.size > maxSize) {
      dispatch({
        type: "UPDATE",
        data: { toast1: true, toastText: "동영상은 최대 50MB까지 올릴 수 있어요." },
      });
      return null;
    }

    const formData: any = new FormData();
    formData.append("seqPartner", seqPartner);
    formData.append("seqPartnerCoach", seqPartnerCoach);
    formData.append("videoFile", newInput);

    uploadVideoToServer(formData);
  };

  const uploadVideoToServer = async (formData: FormData) => {
    try {
      dispatch({ type: "LOADING_START" });
      await api
        .post("/community/video/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          setVideoFiles([
            ...videoFiles,
            {
              fileId: data.fileId,
              fileName: data.fileName,
              thumbNail: data.thumbNail,
              fileData: formData.get("videoFile"),
            },
          ]);
        });
      dispatch({ type: "LOADING_END" });
    } catch (error) {
      dispatch({ type: "LOADING_END" });
      console.error(error);
    }
  };

  return (
    <>
      <div className="add-comunity-edit">
        <label className="btn" onClick={handleSelectImageButton}>
          <img src={pictureIcon} />
          <input
            type="file"
            accept="image/*"
            ref={imageFileRef}
            disabled={imageFiles.length === 4}
            onChange={(e: any) => {
              if (e.target.files[0].size === 0) return;
              selectImageFile();
            }}
          />
        </label>
        <label className="btn" onClick={handleSelectVideoButton}>
          <img src={videoIcon} />
          <input
            type="file"
            accept="video/mp4,video/mkv, video/x-m4v,video/*"
            disabled={videoFiles.length > 0}
            onInput={selectVideoFile}
          />
        </label>

        <div className="btn" onClick={handleAddLinkButton}>
          <img src={linkIcon} />
        </div>
      </div>
      <AddVideoLink
        open={openAddLink}
        setOpenAddLink={setOpenAddLink}
        videoLinks={videoLinks}
        setVideoLinks={setVideoLinks}
        linkToEdit={linkToEdit}
        setLinkToEdit={setLinkToEdit}
      />
      <ImageEditorPop file={imageFileRef} getData={getImageData} />
      <ImageEditorUpdPop file={imageFileRef} getData={getImageDataUpd} src={imageToEdit} />
    </>
  );
};

export default BottomButtons;
